import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Affix extends React.PureComponent {
    state = {
        isShow: false,
    };

    componentDidMount() {
        this.beforeScrollTop = window.scrollY;
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        const { isShow } = this.state;

        const currentTop = window.scrollY;

        if (currentTop === this.beforeScrollTop) {
            return;
        } else if (currentTop - this.beforeScrollTop > 0 && isShow) {
            this.setState({ isShow: false });
        } else if (currentTop - this.beforeScrollTop < 0 && !isShow) {
            this.setState({ isShow: true });
        } else if (currentTop === 0 && isShow) {
            this.setState({ isShow: false });
        }

        this.beforeScrollTop = currentTop;
    };

    /**
     * 回到顶部
     */
    backToTop = () => {
        window.scrollTo(0, 0);
    };

    /**
     * 渲染组件
     */
    render() {
        const { isShow } = this.state;

        const affix = (
            <React.Fragment>
                <div className={styles.toTop}>
                    <a onClick={this.backToTop} />
                </div>
                <div className={styles.toHome}>
                    <a href="//i.ifeng.com/?srctag=zbs_article_home2" target="_blank" />
                </div>
            </React.Fragment>
        );

        return isShow ? ReactDOM.createPortal(affix, document.body) : null;
    }
}

export default errorBoundary(Affix);
